<template>
  <NuxtLayout>
    <NuxtPage />
    <ConfirmModal />
  </NuxtLayout>
</template>

<script setup>

</script>


<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

</style>